const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-type" */ '@/pages/base-info/order-properties/item-type/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-type" */ '@/pages/base-info/order-properties/item-type/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-type" */ '@/pages/base-info/order-properties/item-type/edit.vue'
  )

export default {
  path: 'item-type',
  meta: {
    label: 'itemFeature',
    auth: 'itemType'
  },
  component: {
    name: 'ItemType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesItemType',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesItemType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesItemType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
